import { Link } from "react-router-dom";
import { MOOD } from "../lib/api";

export const EmptyState = ({ text = "O acervo está sendo preparado. Volte em breve.", testid = "empty-state" }) => (
  <div className="grid gap-6 md:grid-cols-[1fr_1.4fr]" data-testid={testid}>
    <div className="relative aspect-[4/3] overflow-hidden">
      <img src={MOOD[1]} alt="" className="h-full w-full object-cover opacity-70" />
      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#08080a]" />
    </div>
    <div className="flex flex-col justify-center border border-rose-900/30 p-8 sm:p-12">
      <p className="eyebrow mb-3">Em breve</p>
      <p className="font-serif-d text-2xl italic text-white sm:text-3xl">{text}</p>
      <Link to="/" className="mt-6 text-sm uppercase tracking-[0.2em] text-rose-400 hover:text-rose-300" data-testid={`${testid}-home-link`}>Voltar ao início</Link>
    </div>
  </div>
);
